"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalToInternalEnumMappings = void 0;
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const EnumConverter_1 = require("../Utils/EnumConverter");
/* tslint:disable:typedef - Disable this to make declaring these classes a bit easier */
/**
 * Maps enums used by the external-api-contract to the enums used
 * in the internal-api-contract, which developers code against.
 */
class ExternalToInternalEnumMappings {
}
exports.ExternalToInternalEnumMappings = ExternalToInternalEnumMappings;
ExternalToInternalEnumMappings.filterDomainType = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.FilterDomainType.Relevant]: api_internal_contract_js_1.FilterDomainType.Relevant,
    [api_external_contract_js_1.FilterDomainType.Database]: api_internal_contract_js_1.FilterDomainType.Database,
});
ExternalToInternalEnumMappings.nullOptions = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.FilterNullOption.AllValues]: api_internal_contract_js_1.FilterNullOption.AllValues,
    [api_external_contract_js_1.FilterNullOption.NonNullValues]: api_internal_contract_js_1.FilterNullOption.NonNullValues,
    [api_external_contract_js_1.FilterNullOption.NullValues]: api_internal_contract_js_1.FilterNullOption.NullValues,
});
ExternalToInternalEnumMappings.filterUpdateType = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.FilterUpdateType.Add]: api_internal_contract_js_1.FilterUpdateType.Add,
    [api_external_contract_js_1.FilterUpdateType.All]: api_internal_contract_js_1.FilterUpdateType.All,
    [api_external_contract_js_1.FilterUpdateType.Remove]: api_internal_contract_js_1.FilterUpdateType.Remove,
    [api_external_contract_js_1.FilterUpdateType.Replace]: api_internal_contract_js_1.FilterUpdateType.Replace,
});
ExternalToInternalEnumMappings.setVisibilityType = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.ZoneVisibilityType.Show]: true,
    [api_external_contract_js_1.ZoneVisibilityType.Hide]: false,
});
ExternalToInternalEnumMappings.setReplaySpeedType = new EnumConverter_1.EnumConverter({
    // these numbers are duration multipliers
    // 2.0, for example, doubles the duration of the replay, slowing it down to 0.5x speed
    [api_external_contract_js_1.ReplaySpeedType.Slow]: 2.0,
    [api_external_contract_js_1.ReplaySpeedType.Normal]: 1.0,
    [api_external_contract_js_1.ReplaySpeedType.Fast]: 0.5,
});
ExternalToInternalEnumMappings.sheetType = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.SheetType.Dashboard]: api_internal_contract_js_1.SheetType.Dashboard,
    [api_external_contract_js_1.SheetType.Worksheet]: api_internal_contract_js_1.SheetType.Worksheet,
    [api_external_contract_js_1.SheetType.Story]: api_internal_contract_js_1.SheetType.Story,
});
ExternalToInternalEnumMappings.showDataTableFormatType = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.IncludeDataValuesOption.AllValues]: api_internal_contract_js_1.ApiShowDataTableFormat.NativeAndFormattedValues,
    [api_external_contract_js_1.IncludeDataValuesOption.OnlyNativeValues]: api_internal_contract_js_1.ApiShowDataTableFormat.NativeValuesOnly,
    [api_external_contract_js_1.IncludeDataValuesOption.OnlyFormattedValues]: api_internal_contract_js_1.ApiShowDataTableFormat.FormattedValuesOnly,
});
ExternalToInternalEnumMappings.periodType = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.PeriodType.Years]: api_internal_contract_js_1.DateStepPeriod.Years,
    [api_external_contract_js_1.PeriodType.Quarters]: api_internal_contract_js_1.DateStepPeriod.Quarters,
    [api_external_contract_js_1.PeriodType.Months]: api_internal_contract_js_1.DateStepPeriod.Months,
    [api_external_contract_js_1.PeriodType.Weeks]: api_internal_contract_js_1.DateStepPeriod.Weeks,
    [api_external_contract_js_1.PeriodType.Days]: api_internal_contract_js_1.DateStepPeriod.Days,
    [api_external_contract_js_1.PeriodType.Hours]: api_internal_contract_js_1.DateStepPeriod.Hours,
    [api_external_contract_js_1.PeriodType.Minutes]: api_internal_contract_js_1.DateStepPeriod.Minutes,
    [api_external_contract_js_1.PeriodType.Seconds]: api_internal_contract_js_1.DateStepPeriod.Seconds,
    [api_external_contract_js_1.PeriodType.IsoYears]: api_internal_contract_js_1.DateStepPeriod.IsoYears,
    [api_external_contract_js_1.PeriodType.IsoQuarters]: api_internal_contract_js_1.DateStepPeriod.IsoQuarters,
    [api_external_contract_js_1.PeriodType.IsoWeeks]: api_internal_contract_js_1.DateStepPeriod.IsoWeeks,
});
ExternalToInternalEnumMappings.dateRangeType = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.DateRangeType.Last]: api_internal_contract_js_1.DateRangeType.Last,
    [api_external_contract_js_1.DateRangeType.LastN]: api_internal_contract_js_1.DateRangeType.LastN,
    [api_external_contract_js_1.DateRangeType.Next]: api_internal_contract_js_1.DateRangeType.Next,
    [api_external_contract_js_1.DateRangeType.NextN]: api_internal_contract_js_1.DateRangeType.NextN,
    [api_external_contract_js_1.DateRangeType.Current]: api_internal_contract_js_1.DateRangeType.Current,
    [api_external_contract_js_1.DateRangeType.ToDate]: api_internal_contract_js_1.DateRangeType.ToDate,
});
ExternalToInternalEnumMappings.dialogStyles = new EnumConverter_1.EnumConverter({
    [api_external_contract_js_1.DialogStyle.Window]: api_internal_contract_js_1.DialogStyle.Window,
    [api_external_contract_js_1.DialogStyle.Modal]: api_internal_contract_js_1.DialogStyle.Modal,
    [api_external_contract_js_1.DialogStyle.Modeless]: api_internal_contract_js_1.DialogStyle.Modeless,
});
/* tslint:enable:typedef */
//# sourceMappingURL=ExternalToInternalEnumMappings.js.map